module.exports = "//d2t2kh5dwcod2h.cloudfront.net/c31664e94d638d7b4514486002e924e624028c1b/images/venmoBadge.png";